<template>
  <div>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <table class="basic-tbl" id="colored-table">
              <thead>
                <tr>
                  <th style="width: 10%">{{ $t("RequesterName") }}</th>
                  <th style="width: 14%">{{ $t("RequesterUsername") }}</th>
                  <th style="width: 10%">{{ $t("Departman") }}</th>
                  <th style="width: 10%">{{ $t("Supplier") }}</th>
                  <th style="width: 13%">{{ $t("DeliveryDate") }}</th>
                  <th style="width: 13%">{{ $t("CreateOn") }}</th>
                  <th style="width: 40%">{{ $t("Description") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style="width: 10%">
                    {{ model.requesterInfo ? model.requesterInfo.name : "-" }}
                  </td>
                  <td style="width: 14%">
                    {{
                      model.requesterInfo ? model.requesterInfo.userName : "-"
                    }}
                  </td>
                  <td style="width: 15%">
                    {{ model.departmentUnit ? model.departmentUnit.name : "-" }}
                  </td>
                  <td>
                    {{
                      model.supplierInfo ? model.supplierInfo.supplierName : "-"
                    }}
                  </td>
                  <td style="width: 20%">
                    {{
                      model.persianDeliveryClock
                        ? model.persianDeliveryClock
                        : "-"
                    }}
                  </td>
                  <td style="width: 13%">
                    {{ model.persianCreateOn ? model.persianCreateOn : "-" }}
                  </td>

                  <td style="width: 33%">
                    {{ model.description ? model.description : "-" }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="vx-card mt-5">
      <div class="vx-card__body card-body">
        <h3>
          {{ $t("PurchaseOrder") }}

        </h3>
        <div class="vx-row mt-5">
          <div class="vx-col w-full mb-base">
            <vs-table :data="model.purchaseItems" class="custom-tbl">
              <template slot="thead">
                <th style="width: 5%">#</th>
                <th style="width: 10%">{{ $t("ProductName") }}</th>
                <th style="width: 14%">{{ $t("ModelNumber") }}</th>
                <th style="width: 10%">{{ $t("UnitPrices") }}</th>
                <th style="width: 10%">{{ $t("Unit") }}</th>
                <th style="width: 10%">{{ $t("Amounts") }}</th>
                <th style="width: 10%">{{ $t("TotalAmount") }}</th>
                <!-- <th style="width: 10%">{{ $t("Action") }}</th> -->
              </template>

              <template slot-scope="{ data }">
                <vs-tr v-for="(row, index) in data" :key="index">
                  <vs-td>
                    {{ index + 1 }}
                  </vs-td>
                  <vs-td style="width: 25%">
                    {{ row.purchaseOrderProductInfo.name }}
                  </vs-td>
                  <vs-td style="width: 20%">
                    {{ row.purchaseOrderProductInfo.modelNumber }}
                  </vs-td>

                  <vs-td>
                    <vs-input
                      type="number"
                      v-model="row.unitPrice"
                      :disabled="!editUnitClicked"
                    />
                  </vs-td>
                  <vs-td>
                    {{ row.unitOfMeasure.name }}
                  </vs-td>
                  <vs-td>
                    {{ row.count }}
                  </vs-td>
                  <vs-td>
                    {{ row.amount }}
                  </vs-td>
                  <!-- <vs-td>
                    <vs-button
                      radius
                      color="danger"
                      size="small"
                      type="gradient"
                      icon-pack="feather"
                      icon="icon-x"
                      @click.prevent="deleteProduct(index)"
                      class="d-inline"
                    ></vs-button>
                  </vs-td> -->
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
        <div class="flex justify-end mt-3 w-full">
      <table class="basic-tbl w-1/5" id="colored-table">
        <thead>
          <tr>
            <th style="width: 10%">{{ $t("TotalAmount") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="width: 10%">
              {{ model.totalAmount ? model.totalAmount : "-" }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
      </div>
    </div>
    <div v-if="model.purchaseOrderDeductionAndIncrease.length>0" class="vx-card mt-5">
      <div class="vx-card__body card-body">
        <h3>
          {{ $t("DeductionAndIncrease") }}

        </h3>
        <div class="vx-row mt-5">
          <div class="vx-col w-full mb-base">
            <table class="basic-tbl" id="colored-table">
              <thead class="z-0 relative">
                <tr>
                  <th style="width: 5%">#</th>
                <th style="width: 10%">{{ $t("DeductionAndIncreaseType") }}</th>
                <th style="width: 10%">{{ $t("ToleranceType") }}</th>
                <th style="width: 10%">{{ $t("Amounts") }}</th>
                <th style="width: 10%">{{ $t("Description") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in model.purchaseOrderDeductionAndIncrease">
                  <td>{{ index + 1 }}</td>
                  <td style="width: 10%">
                  <div>
                    {{
                      row.deductionAndIncreaseType &&
                      row.deductionAndIncreaseType === 1
                        ? "کسر"
                        : "اضافه"
                    }}
                  </div>
                </td>
                <td style="width: 10%">

                  <div >
                    {{
                      row.toleranceType && row.toleranceType === 1
                        ? "درصدی"
                        : "مقداری"
                    }}
                  </div>
                </td>

                <td style="width: 10%">

                  <div >
                    {{ row.amount ? row.amount : "-" }}
                  </div>
                </td>
                <td style="width: 30%">
                  <div>
                    {{ row.description ? row.description : "-" }}
                  </div>
                </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import { mapActions } from "vuex";

export default {
  name: "warehouseManagement_CheckinTransactions_Details",
  data() {
    return {
      allUnits: [],
      headerInfo: {},
      model: {},
      editable: true,
      editClicked: false,
      productName: "",
      modelNumber: "",
      amount: 0,
      unit: {},
    };
  },

  mounted() {
    this.load();
  },
  methods: {
    ...mapActions({
      fetchPurchaseOrder: "purchaseOrder/fetchPurchaseOrder",
    }),
    load() {
      var id = this.$route.params.id;
      this.fetchPurchaseOrder(id).then((r) => {
        this.model = r;
      });

      console.log(this.model);
    },
  },
};
</script>
